/**
 * Хранилище модуля PageRegularDelivery
 * @module PageRegularDelivery/Store
 * @requires Vue
 * @requires Vuex
 * */

import Vue from 'vue'
import Vuex from 'vuex'
import * as apiService from 'API/delivery'

import storeModule from 'PageShop/store/store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: () => ({
    regularDelivery: {
      selectedRegion: '',
      regions: [],
      stores: [],
      selectedStoreId: ''
    }
  }),
  getters: {
    deserializeRegion: () => data => ({
      label: data.name,
      value: data.id
    }),
    deserializeShop: () => data => ({
      address: data.address.addr,
      id: data.id
    })
  },
  actions: {
    async searchRegions({ commit, getters }, filterString) {
      try {
        const { data } = await apiService.searchRegion(filterString)
        commit('updateRegularDelivery', {
          regions: data.regions.map(el => getters.deserializeRegion(el))
        })
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async getStores({ commit, getters }, regionId) {
      try {
        const { data } = await apiService.getStoresByRegionId(regionId)
        commit('updateRegularDelivery', {
          stores: data?.[0]?.shops?.map(el => getters.deserializeShop(el)) ?? []
        })
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async selectStore({ commit }, storeId) {
      commit('updateRegularDelivery', { selectedStoreId: storeId })
    }
  },
  mutations: {
    updateRegularDelivery(state, patch) {
      Vue.set(state, 'regularDelivery', {
        ...state.regularDelivery,
        ...patch
      })
    },
    /*setShopId(state, shopId) {
      Vue.set(state, 'regularDelivery', {
        ...state.regularDelivery,
        selectedStoreId: shopId
      })
    }*/
  },
  modules: {
    storeModule
  }
})
